import { withJsonFormsControlProps } from '@jsonforms/react';
import { MoneyOnly } from './MoneyOnly';

const MoneyOnlyControl = ({ data, handleChange, path, schema, errors, visible, label }) => {
  return (
    <MoneyOnly
      value={data}
      updateValue={(newValue) => handleChange(path, newValue)}
      path={path}
      description={schema?.description ?? ''}
      errors={errors}
      visible={visible}
      label={label}
    />
  );
};

export default withJsonFormsControlProps(MoneyOnlyControl);
